







import { defineComponent } from '@vue/composition-api';
import CorpTube from '@/components/CorpTube.vue';
import ContextInfo from '@/data/settings/ContextInfo';

export default defineComponent({
  name: 'App',
  props: {
    contextInfo: {
      type: ContextInfo,
      default: new ContextInfo('')
    },
    videoId: {
      type: String,
      default: undefined
    }
  },
  components: {
    CorpTube
  }
});
